const AMBIT = 'Ambit';
const SOLAR_SPECTRUM = 'Solar Spectrum';
const XOOM = 'Xoom';

export { AMBIT, SOLAR_SPECTRUM, XOOM };

export const IneligibleForReferral = [AMBIT, XOOM, SOLAR_SPECTRUM];
